import { useCallback, useRef } from 'react';

// Fantasy hover sound - a soft magical chime
const createHoverSound = () => {
  const audioContext = new (window.AudioContext || (window as any).webkitAudioContext)();
  
  // Create a soft chime sound
  const oscillator = audioContext.createOscillator();
  const gainNode = audioContext.createGain();
  
  oscillator.connect(gainNode);
  gainNode.connect(audioContext.destination);
  
  // Soft fantasy sound - high pitch with quick decay
  oscillator.type = 'sine';
  oscillator.frequency.setValueAtTime(880, audioContext.currentTime); // A5 note
  oscillator.frequency.exponentialRampToValueAtTime(1320, audioContext.currentTime + 0.05); // Quick rise to E6
  oscillator.frequency.exponentialRampToValueAtTime(1760, audioContext.currentTime + 0.1); // Rise to A6
  
  // Very soft volume with quick fade
  gainNode.gain.setValueAtTime(0.03, audioContext.currentTime);
  gainNode.gain.exponentialRampToValueAtTime(0.001, audioContext.currentTime + 0.15);
  
  oscillator.start(audioContext.currentTime);
  oscillator.stop(audioContext.currentTime + 0.15);
};

export const useHoverSound = () => {
  const lastPlayed = useRef<number>(0);
  
  const playHoverSound = useCallback(() => {
    const now = Date.now();
    // Throttle to prevent rapid fire sounds
    if (now - lastPlayed.current > 50) {
      lastPlayed.current = now;
      try {
        createHoverSound();
      } catch (e) {
        // Silently fail if audio context not supported
      }
    }
  }, []);

  return { playHoverSound };
};
